import type { InputSampleFileMappingInput, InputSampleValueInput } from "@/graphql.ts";
import { hasLicense, LICENSE_MODULE } from "@/modules/app/utils/license";
import { getProjectFilesFromSampleAttribute } from "@/modules/workflow/graphql/queries.ts";

export async function getSampleFileMappings(
  attributeId: number,
  sampleIds: number[],
): Promise<InputSampleValueInput["sampleFileMappings"]> {
  const validSampleIds = sampleIds.filter((id) => id > 0);

  const hasTrackerLicense = await hasLicense(LICENSE_MODULE.TRACKER);
  if (!hasTrackerLicense) {
    return [];
  }

  const { data } = await getProjectFilesFromSampleAttribute({ attributeIds: [attributeId], sampleIds: validSampleIds });

  return sampleIds.map((id) => {
    if (id < 0) {
      return {
        sampleId: id,
        fileIds: null,
      };
    }

    const sample = data?.sample?.samples?.find((sample) => sample?.id === id);

    return sample == null
      ? {
          sampleId: id,
          fileIds: null,
        }
      : ({
          sampleId: sample.id,
          fileIds:
            sample.valuesByAttributeId
              .find((v) => v?.attribute?.id === attributeId)
              ?.valueList?.map((list) => {
                if (list?.projectFile == null) return null;
                const file = list.projectFile;
                return file ? (file.deleted ? -2 : file.hidden ? -1 : file.id) : null;
              })
              .filter((fileId): fileId is number => fileId !== null) ?? [],
        } satisfies InputSampleFileMappingInput);
  });
}
